import { render, staticRenderFns } from "./ViewDoc.vue?vue&type=template&id=0ecdcb7f&scoped=true"
import script from "./ViewDoc.vue?vue&type=script&lang=js"
export * from "./ViewDoc.vue?vue&type=script&lang=js"
import style0 from "./ViewDoc.vue?vue&type=style&index=0&id=0ecdcb7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecdcb7f",
  null
  
)

export default component.exports